import { useMemo } from 'react';
import type { AnswerProps } from './AnswerControls';
import { countWords } from './words';

/**
 * The box a candidate writes an essay in.
 *
 * The real exam shows a live word count and nothing else: no target, no
 * running commentary on how far short the answer is. The task states the
 * length it wants, the count says where the candidate has got to, and the
 * arithmetic between them is the candidate's own — which is the arithmetic
 * they will be doing on the day.
 */
export function EssayControl({
  number,
  answer,
  disabled,
  onChange,
  onFocus,
}: AnswerProps) {
  const text = answer?.value ?? '';

  // Recomputed on every keystroke, which is the whole point of it.
  const words = useMemo(() => countWords(text), [text]);

  return (
    <div className="essay">
      {/* No heading over the box and nothing written in it: the real screen
          gives a candidate an empty rectangle and the count beneath it. */}
      <textarea
        className="essay__box"
        aria-label={`Your answer for part ${number}`}
        spellCheck={false}
        disabled={disabled}
        value={text}
        onFocus={onFocus}
        onChange={(e) => onChange({ value: e.target.value })}
      />
      <div className="essay__meter" aria-live="polite">
        <span className="essay__count">Words: {words}</span>
      </div>
    </div>
  );
}
